module.exports = __webpack_public_path__ + "assets/8e641e80c4f826869d0f04bfc1c315ee.png";